"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  BUYER_EMAIL: 'buyerEmail',
  CREATED_BY: 'createdBy',
  DOCUMENTATION_LINK: 'documentationLink',
  EXAMPLE_LINK: 'exampleLink',
  IS_FREE: 'isFree',
  PAYMENT_TYPE: 'paymentType',
  PRICE: 'price',
  PROVIDER_WEBSITE: 'providerWebsite',
  PROVIDER_EMAIL: 'providerEmail',
  REFUND: 'refund',
  REFUND_REQUESTED_DATE: 'refundRequestedDate',
  REVIEW: 'review',
  TRANSACTION_ID: 'transactionId'
};
exports.default = _default;
module.exports = exports.default;